import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=13784364&scoped=true"
import script from "./ModalFrame.vue?vue&type=script&lang=js"
export * from "./ModalFrame.vue?vue&type=script&lang=js"
import style0 from "./ModalFrame.vue?vue&type=style&index=0&id=13784364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13784364",
  null
  
)

export default component.exports